import React from 'react';
import { Badge, List, Popover, ScrollArea, Text } from '@mantine/core';

// Advisory per-flow quality grade from the LLM-as-judge pass (§6B). Click to see the summary + findings.
const GRADE_COLOR = { pass: 'green', warn: 'yellow', fail: 'red' };

export default function FlowGradeBadge({ grade }) {
  if (!grade || !grade.score) return null;
  const color = GRADE_COLOR[grade.score] || 'gray';
  const findings = grade.findings || [];
  return (
    <Popover width={320} position="bottom-start" withArrow shadow="md">
      <Popover.Target>
        <Badge size="xs" variant="light" color={color} style={{ cursor: 'pointer' }}>
          judge: {grade.score}{findings.length ? ` (${findings.length})` : ''}
        </Badge>
      </Popover.Target>
      <Popover.Dropdown>
        {/* Scroll the findings INSIDE the dropdown (bounded height) so a long list never overflows the
            viewport — otherwise the engineer scrolls the page to read it and the popover dismisses. */}
        <ScrollArea.Autosize mah={360} type="auto">
          {grade.autoRebuild && (
            <Text size="xs" c="dimmed" mb={4}>
              {grade.autoRebuild === 'rebuilt'
                ? 'This flow was auto-rebuilt once to address a failed judge review; this is the re-judged grade.'
                : 'An auto-rebuild was attempted but failed validation — this is the original flow and its grade.'}
            </Text>
          )}
          {grade.summary && <Text size="xs" mb={findings.length ? 'xs' : 0}>{grade.summary}</Text>}
          {findings.length > 0 ? (
            <List size="xs" spacing={4}>
              {findings.map((fd, i) => (
                <List.Item key={i}>
                  <Text span fw={600} c={fd.severity === 'high' ? 'red' : fd.severity === 'medium' ? 'orange' : 'dimmed'} size="xs">
                    [{fd.severity || 'note'}]{' '}
                  </Text>
                  {fd.issue}{fd.fix ? <Text span c="dimmed" size="xs"> — {fd.fix}</Text> : null}
                </List.Item>
              ))}
            </List>
          ) : (
            <Text size="xs" c="dimmed">No findings — ready for review.</Text>
          )}
        </ScrollArea.Autosize>
      </Popover.Dropdown>
    </Popover>
  );
}
